module.exports = __webpack_public_path__ + "img/pic2.caf09101.png";